export default {
    url: '/import',
    template: '<evaluation-import forms="vm.forms" company="vm.company"/>',
    resolve: {
        forms ($stateParams, FormResource, FORMS_TYPE_ENUM, ROLE_COMPANY_MODULE_PRIVILEGE_ENUM) {
            return FormResource.query({
                type: FORMS_TYPE_ENUM.KEYS.FORM_360_FEEDBACK,
                'privileges[]': [ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.FORMS_360_MANAGE]
            }).$promise;
        },
        company (CompanyResource, TokenService) {
            return CompanyResource.publicView({ id: TokenService.getCompanyId(), expand: 'evaluationI18ns' }).$promise;     // todo.. find evaluationI18ns
        }
    },
    controller (forms, company) {
        this.forms = forms;
        this.company = company;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/evaluation/import/index.js